import { useMemo, useState } from 'react';

/**
 * Estado de ordenamiento para tablas admin (TanStack Table + API paginada).
 */
export function useTableSorting(initialSorting = []) {
  const [sorting, setSorting] = useState(initialSorting);

  const active = sorting[0];
  const sortBy = active?.id ?? '';
  const sortDir = active?.desc ? 'desc' : 'asc';

  const sortQuery = useMemo(() => {
    if (!sortBy) return '';
    const params = new URLSearchParams();
    params.set('sortBy', sortBy);
    params.set('sortDir', sortDir);
    return params.toString();
  }, [sortBy, sortDir]);

  const appendSortParams = (params) => {
    if (sortBy) {
      params.set('sortBy', sortBy);
      params.set('sortDir', sortDir);
    }
    return params;
  };

  return {
    sorting,
    setSorting,
    sortBy,
    sortDir,
    sortQuery,
    appendSortParams,
  };
}
